export default "__VITE_ASSET__BFfCR2Je__"